export const NavigationRoutesNames = {
  POINTS: 'points',
  TRANSACTIONS: 'transactions',
  ANALYTICS: 'analytics',
  FINANCE: 'finance',
  SETTINGS: 'settings'
} as const
